module.exports = "<footer class=\"footer\">\r\n  <!-- LFWM 3662 removed the footer logo -->\r\n  <!-- <div align=\"right\" class=\"\">\r\n    <span>\r\n      <img src=\"assets/images/svg/logo-footer-lifungcompany.svg\" width=\"150px\">\r\n    </span>\r\n  </div> -->\r\n</footer>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/layout/home/footer/footer.component.html
// module id = ../../../../../src/app/layout/home/footer/footer.component.html
// module chunks = main